var CONFUSEDCMS = CONFUSEDCMS || {};
CONFUSEDCMS.VehicleDetails = CONFUSEDCMS.VehicleDetails || {};

(function (ns, $) {
    'use strict';

    ns.Constants = {
        MinDate: '0001-01-01T00:00:00',
        ValidText: 'valid',
        InvalidText: 'invalid',
        ValidClass: 'mot-checker__results__result mot-checker__results__result--ok',
        InvalidClass: 'mot-checker__results__result mot-checker__results__result--alert'
    };

    ns.Utils = {
        FormatDate: function (date) {
            var d = new Date(date || Date.now()),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) {
                month = '0' + month;
            }
            if (day.length < 2) {
                day = '0' + day;
            }

            return [day, month, year].join('/');
        },
        ValidateForm: function ($form) {
            return $form.valid();
        }

    };

    ns.Vehicle = function () {
        var self = this;
        self.RegNumber = ko.observable('');
        self.MotExpiry = ko.observable('');
        self.Make = ko.observable('');
        self.Model = ko.observable('');
        self.Display = function() {
            var display = self.RegNumber();
            if (self.Make() !== '') {
                display += ', ' + self.Make() + ' ';
            }
            if (self.Model() !== '') {
                display += self.Model();
            }

            return display;
        };

        self.ValidExpiryDate = function() {
            if (self.MotExpiry() === ns.Constants.MinDate) {
                return false;
            }
            return true;
        };

        self.ValidMot = function () {
            if (!self.ValidExpiryDate()) {return false;}

            var today = new Date();
            var motDate = new Date(self.MotExpiry());

            if (today > motDate) {
                return false;
            }
            return true;
        };

        self.FormattedMotExpiry = function() {
            return ns.Utils.FormatDate(self.MotExpiry());
        };

        self.ValidityText = function() {
            if (self.ValidMot()) {
                return ns.Constants.ValidText;
            }

            return ns.Constants.InvalidText;
        };

    };

    ns.MotChecker = function () {
        var self = this;
        self.Vehicle = new ns.Vehicle();
        self.ShowSearch = ko.observable(true);
        self.VehicleNotFound = ko.observable(false);
        self.VehicleErrorOccurred = ko.observable(false);
        self.Form = '';

        self.InitialiseModule = function ($form) {
            var motCheckerDOMLocation;
            var parentDiv = $('.box--simple');
            var motCheckerSelecter = '.mot-checker';
            $.each(parentDiv, function (i, elem) {
                if ($(elem).find(motCheckerSelecter)) {
                    motCheckerDOMLocation = parentDiv[i];
                    return false;
                }
            });
            if (!motCheckerDOMLocation) {
                motCheckerDOMLocation = motCheckerSelecter;
            }
            self.Form = $form;
            ko.applyBindings(self, motCheckerDOMLocation);
        };

        self.MotClass = function() {
            if (self.Vehicle.ValidMot()) {
                return ns.Constants.ValidClass;
            }

            return ns.Constants.InvalidClass;
        };

        self.ResetForm = function () {
            self.Vehicle.RegNumber('');
            self.ShowSearch(true);
            self.VehicleNotFound(false);
            self.VehicleErrorOccurred(false);
        };

        self.GetDetails = function () {
            var result = ns.Utils.ValidateForm(self.Form);
            if (result) {
                self.VehicleNotFound(false);
                self.Vehicle.RegNumber($('#regNumber').val());

                $.ajax({
                    url: '/api/lookupv2/VehicleRunningDetails',
                    contentType: 'text/json',
                    type: 'POST',
                    data: ko.toJSON({
                        RegNumber: self.Vehicle.RegNumber()
                    }),
                    success: function(data) {
                        var details = data;
                        if (details != null && details.MotExpiry!==undefined) {
                            self.Vehicle.MotExpiry(details.MotExpiry);
                            self.Vehicle.Make(details.MakeDescription);
                            self.Vehicle.Model(details.ModelDescription);
                            self.VehicleNotFound(false);
                        } else {
                            self.Vehicle.Make('');
                            self.Vehicle.Model('');
                            self.VehicleNotFound(true);
                        }

                        self.ShowSearch(false);

                    },
                    error: function () {
                        self.Vehicle.Make('');
                        self.Vehicle.Model('');
                        self.VehicleNotFound(true);
                        self.VehicleErrorOccurred(true);
                        self.ShowSearch(false);
                    }
                });
            }
        };

    };
}(CONFUSEDCMS.VehicleDetails, jQuery));
